import { t } from "../core/i18n.js";
import { icon } from "./icons.js";
import { runtime } from "../core/runtime.js";
import { setPage } from "../core/navigation.js";
import { resetTableView } from "./plan-table-view.js";
import { updatePageMetadata } from "../core/seo.js";
import { AUTH_ROUTES } from "../../shared/seo.js";
let ready = false;
const motion = matchMedia("(prefers-reduced-motion: reduce)");
export function showHome(push = true) {
  document.body.dataset.presentation = "home";
  document.body.classList.remove("table-view");
  document.body.classList.remove("menu-open");
  runtime.menuOpen = false;
  if (push && location.pathname !== "/") history.pushState({}, "", "/");
  updatePageMetadata();
  window.DayXAppearance.refresh();
  if (push) window.scrollTo({ top: 0, behavior: "instant" });
}
export function showWorkspace(page = "today", renderPage = true) {
  if (page === "table") resetTableView();
  document.body.dataset.presentation = "workspace";
  window.DayXAppearance.refresh();
  if (renderPage && ready) setPage(page);
  else {
    runtime.page = page;
    if (renderPage && location.pathname !== "/" + page)
      history.pushState({}, "", "/" + page);
  }
  if (renderPage)
    document.getElementById("appPage").focus({ preventScroll: true });
}
export function setExperienceReady() {
  ready = true;
}
export function bindExperience() {
  document.body.classList.add("motion-enabled");
  window.addEventListener(
    "scroll",
    () => {
      document
        .querySelector(".dayx-landing-nav")
        ?.classList.toggle("is-scrolled", window.scrollY > 8);
    },
    { passive: true },
  );
  if (location.pathname === "/") showHome(false);
  else if (AUTH_ROUTES.includes(location.pathname))
    document.body.dataset.presentation = "auth";
  else showWorkspace(location.pathname.split("/")[1], false);
  document.addEventListener("click", (event) => {
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    const home = event.target.closest("[data-home]");
    if (home) {
      event.preventDefault();
      showHome();
      document
        .querySelector(".dayx-landing-nav .wordmark")
        .focus({ preventScroll: true });
      return;
    }
    const link = event.target.closest("[data-enter]");
    if (link) {
      event.preventDefault();
      showWorkspace(link.dataset.enter);
      return;
    }
    if (runtime.menuOpen && !event.target.closest(".sidebar,#menuBtn")) {
      runtime.menuOpen = false;
      document.body.classList.remove("menu-open");
      document.getElementById("menuBtn").setAttribute("aria-expanded", "false");
    }
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && runtime.menuOpen) {
      runtime.menuOpen = false;
      document.body.classList.remove("menu-open");
      document.getElementById("menuBtn").setAttribute("aria-expanded", "false");
      document.getElementById("menuBtn").focus();
    }
  });
  const reveal = new IntersectionObserver(
    (entries) => {
      for (const entry of entries)
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          reveal.unobserve(entry.target);
        }
    },
    { threshold: 0.12 },
  );
  document
    .querySelectorAll("[data-reveal]")
    .forEach((el) => reveal.observe(el));
}
export function enhanceWorkspace() {
  const page = document.getElementById("appPage");
  const previous = page.dataset.view;
  page.dataset.view = runtime.page;
  if (
    previous !== runtime.page &&
    !motion.matches &&
    document.body.dataset.presentation === "workspace"
  ) {
    page.getAnimations().forEach((animation) => animation.cancel());
    page.animate(
      [
        { opacity: 0, transform: "translateY(12px)" },
        { opacity: 1, transform: "translateY(0)" },
      ],
      { duration: 360, easing: "cubic-bezier(.2,.7,.2,1)" },
    );
  }
  const nav = document.querySelector('#sideNav [aria-current="page"]');
  let breadcrumb = document.getElementById("workspaceBreadcrumb");
  if (!breadcrumb) {
    breadcrumb = document.createElement("div");
    breadcrumb.id = "workspaceBreadcrumb";
    breadcrumb.className = "workspace-breadcrumb";
    document
      .querySelector(".topbar")
      .insertBefore(breadcrumb, document.getElementById("dateNavigation"));
  }
  breadcrumb.innerHTML = `${icon("dashboard")}<span>DayX</span><span aria-hidden="true">/</span><strong></strong>`;
  breadcrumb.querySelector("strong").textContent =
    nav?.textContent.trim() || t("Workspace");
}
